import messages from '../locales/ja_JP.json';

const lang = {
    messages: {
        ...messages,
    },
    locale: 'ja-JP',
};
export default lang;
